import { RefObject } from 'react';
import { atom } from 'recoil';
import { Chart } from 'highcharts';
import * as K from 'common/constants';

/**
 * Mutable ref to  track the {@link HighchartsReact} component rendered by a {@link ScalyrGraph} or
 * {@link DistributionGraph} component
 */
export const currentChartRefState = atom<RefObject<{ chart: Chart; container: RefObject<HTMLDivElement> }> | null>({
  key: K.RECOIL_ATOM_KEY.CURRENT_CHART_REF,
  default: null,
  dangerouslyAllowMutability: true,
});
